import * as React from 'react';

interface Props {
  className?: string;
}

export const SkeletonLoader: React.FC<Props> = ({ className }) => (
  <div className={`skeletonLoader ${className || 'skeletonLoader--med'}`} />
);
